<template>
  <aside v-if="menuAberto" :class="{ 'menu-lateral': abrirMenu }" class="pt-70 d-flex flex-column left-sidebar">
    <div
      style="border-bottom: 1px solid #e5e5e5"
      :class="LayoutType == 'mini-sidebar' ? 'select-mini' : ''"
    >
      <b-avatar
        style="margin: 12px"
        v-if="LayoutType == 'mini-sidebar'"
        :src="
          listaEmpresas.find((el) => el.value == selectedCompany)
            ? listaEmpresas.find((el) => el.value == selectedCompany).logo
            : ''
        "
      />
      <div
        class="select-mini__select"
        :class="LayoutType == 'mini-sidebar' ? 'p-1' : ''"
      >
        <!--<span class="pt-1 pl-2 font-size-11" v-if="LayoutType != 'mini-sidebar'">Empresa selecionada:</span>-->
        <input-empresa
          class="p-1"
          size="sm"
          :options="listaEmpresas"
          v-model="selectedCompany"
        />
      </div>
    </div>

    <ul class="nav flex-column mb-5">
      <template v-for="(route, i) in filteredMenu">
        <menu-item
          :route="route"
          :key="`${route.id}_${i}`"
          v-if="executarFuncaoMenu(route)"
          :tree-stage="0"
        ></menu-item>
      </template>
    </ul>
    <div
      class="link-aneel"
      :class="{
        'avatar': LayoutType === 'mini-sidebar',
        'link-aneel-menu-mobile': menuAberto,
      }"
    >
      <img src="@/assets/images/logo-aneel.svg" class="link-aneel__img" />
      <a
        href="https://www.gov.br/aneel/pt-br/assuntos/programa-de-pesquisa-desenvolvimento-e-inovacao"
        class="link-aneel__text"
        target="_blank"
        >Regulamentação ANEEL</a
      >
    </div>
  </aside>
</template>
<script>
import { mapState } from "vuex";
//import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import jwt_decode from "jwt-decode";
import cloneDeep from "lodash.clonedeep";
import Menu from "@/common/mock/menu";
import MenuItem from "./components/Menu";
import InputEmpresa from "@/components/inputs/InputEmpresa";

import EmpresasService from "@/common/services/empresas/empresas.service.js";

export default {
  name: "VerticalSidebar",
  components: {
    //VuePerfectScrollbar,
    MenuItem,
    InputEmpresa,
  },
  data: () => ({
    initialShow: true,
    menu: [],
    interval: null,
    allCompanies: [],
    menuCarregado: false,
  }),
  computed: {
    ...mapState([
      "logoColor",
      "Sidebar_drawer",
      "SidebarColor",
      "LayoutType",
      "menuAberto",
      "abrirMenu"
    ]),

    sizeUsersToAprove: function () {
      return this.$store.state.app.sizeUsersToAprove;
    },

    listaEmpresas: function () {
      return this.$store.getters["app/retornarEmpresas"];
    },

    filteredMenu: function () {
      let token = localStorage.getItem("usuario_token");

      if (!token || this.permissao == null)
        return [];

      let userData = jwt_decode(token);
      if (!userData.role) 
        return [];

      let role = typeof userData.role == "string" ? [userData.role] : userData.role;

      if (role.includes("admin")) 
        return this.filtrarMenuAdmin(this.menu);

      let ctx = this;
      let menuP = this.menu.filter(function f(o) {
        if (o.children) {
          o.children = o.children.filter(f);
        }

        if (userData[o.id] == undefined 
        && !o.children 
        && o.id != "ProjecaoFinanceira") {
          return false;
        }

        if (o.children) 
          return o.children.length > 0;

        if (!o.chavePermissao) 
          return true;

        if (!ctx.$store.getters["app/retornaPermissao"](o.chavePermissao).r)
          return false;

        if (o.role.length == 0) 
          return true;

        if (o.role.length > 0)
          return o.role.some((el) => role.includes(el));

        return false;
      });
      return menuP;
    },

    permissao: function () {
      return this.$store.state.app.permissao;
    },

    selectedCompany: {
      get: function () {
        return this.$store.state.app.selectedCompany;
      },
      set: function (value) {
        let empresaSelecionada = this.listaEmpresas.find((el) => el.value == value);
        this.$store.commit("app/setSelectedCompany", empresaSelecionada);

        if (this.$route.path !== "/dashboard") {
          this.$router.push({ name: "dashboard" });
        }
      },
    },
  },
  methods: {
    executarFuncaoMenu(route) {
      if (route.funcao) {
        return route.funcao(this);
      }
      return true;
    },

    filtrarMenuAdmin(menu) {
      return menu.filter(function f(el) {
        if (el.children) {
          el.children = el.children.filter(f);
        }

        return !el.excetoAdmin;
      });
    },

    showMobileSidebar() {
      this.$store.commit("SET_SIDEBAR_DRAWER", false);
    },

    abrirPerfis() {
      this.$router.push({ name: "perfis" });
    },

    getUsuarioAprovacao: function () {
      let token = localStorage.getItem("usuario_token");
      if (!token) return false;

      let userData = jwt_decode(token);

      if (!userData.role) return false;

      let role =
        typeof userData.role == "string" ? [userData.role] : userData.role;

      if (role.includes("admin"))
        this.$store.dispatch("app/fetchSizeUsersToAprove");
    },

    getRole: function () {
      let token = localStorage.getItem("usuario_token");
      if (!token) return [];

      let userData = jwt_decode(token);

      if (!userData.role) return [];

      let role =
        typeof userData.role == "string" ? [userData.role] : userData.role;

      return role;
    }
  },
  mounted() {
    this.menu = cloneDeep(Menu);
    this.getUsuarioAprovacao();

    this.interval = setInterval(() => {
      this.getUsuarioAprovacao();
    }, 60000);

    this.menuCarregado = false;
    // this.$store.commit('setMenuCarregado', true);
  },
  beforeMount() {
    if (this.getRole().includes("admin")) {
      EmpresasService.listarDropdown().then((res) => {
        this.allCompanies = res.data.data.map((el) => {
          return {
            value: el.id,
            text: el.nomeFantasia || el.razaoSocial,
            logo: el.logoDaEmpresa,
            data: el,
          };
        });
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    permissao() {
      if (this.menuCarregado) 
        return;

      this.menu = cloneDeep(Menu);
      this.menuCarregado = true;
    },
    selectedCompany() {
      this.menuCarregado = false;
    }
  },
};
</script>
<style>
.pt-70 {
  padding-top: 70px;
}
.menuselect {
  /*background: #ededed; */
}
.menuselect__label {
  position: absolute;
  z-index: 9999;
}
.menuselect__input {
  margin-bottom: 0px !important;
}

.menuselect__input .custom-select {
  border: none;
  background: transparent;
}

.menu-lateral {
  min-width: 320px;
}

.link-aneel {
  background: #ededed;
  border-top: 1px solid #e5e5e5;
  position: fixed;
  bottom: 0;
  width: 320px;
}

.link-aneel.avatar {
  width: 65px !important;
}

.link-aneel__img {
  width: 40px;
  margin: 10px;
}

.link-aneel__text {
}

.link-aneel.avatar .link-aneel__text {
  display: none !important;
}

.link-aneel.avatar:hover .link-aneel__text {
  display: inline-block !important;
}

.link-aneel.avatar:hover {
  width: 235px !important;
}

.mini-sidebar .tree1.routetrue .hide-text {
  display: inline-block;
  padding-left: 10px;
}
.mini-sidebar .tree1.routetrue {
  width: 265px;
  background: #e5e5e5;
}

.select-mini .select-mini__select {
  display: none !important;
}

.select-mini:hover .select-mini__select {
  display: inline-block !important;
  position: absolute;
  /*background: #e5e5e5;*/
  left: 0;
}

/*.select-mini:hover .select-mini__select .form-group {
        margin-bottom: 0;
        padding: 2px !important;
        width: 250px;
    }*/

.select-mini:hover {
  background: #e5e5e5;
}

.mini-sidebar .routefalse .badge {
  display: none;
}

.sem-icon {
  padding: 4px !important;
  padding-left: 24px !important;
  background: #f5f5f5;
}

.mini-sidebar .routefalse .nav-link {
  width: 65px;
}

.sem-icon .icon-route {
  display: none;
}

.menu-border {
  border-bottom: 1px solid #e5e5e5;
}
</style>
